import { PropsWithChildren, useRef } from 'react'
import cx from 'classnames'
import Styles from './ToastMessage.module.scss'
import { InteractOutsideProps, useInteractOutside } from '@react-aria/interactions'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { RIGHT_RAIL_TABS_CONTAINER_ID } from 'components/DocRightRailV2/Tabs/constants'

export type MessageVariant =
  | 'success'
  | 'error'
  | 'info'
  | 'generating'
  | 'loading'
  | 'pink'
  | 'rating'
  | 'designRating'
  | 'generatingSocialCta'
  | 'singleLine'

export interface Props extends Omit<InteractOutsideProps, 'ref'> {
  theme?: 'dark' | 'light'
  variant: MessageVariant
}

export const Root = ({ variant, children, theme = 'light', ...interactOutsideProps }: PropsWithChildren<Props>) => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  useInteractOutside({ ref: wrapperRef, ...interactOutsideProps })
  const { isMobile } = useResponsiveDesign()
  const isAnyModalOpen = document.querySelector('[class^="Modals_stack__"]')
  const isRightRailOpen = document.querySelector(`#${RIGHT_RAIL_TABS_CONTAINER_ID}`) && !isMobile && !isAnyModalOpen
  return (
    <div
      data-theme={theme}
      ref={wrapperRef}
      className={cx(Styles.messageContainer, Styles[variant], {
        [Styles.isRightRailOpen]: isRightRailOpen,
      })}
    >
      {children}
    </div>
  )
}
